import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import RouteLogger from '../../helpers/RouteLogger';

import TerritoriesList from '../../views/Territories/List';

const TerritoriesRoutes=(props)=>{
	return <RouteLogger>
			<Switch>
				<Route path="/territories/:continent?" component={(TerritoriesList)}></Route>
			</Switch>
		</RouteLogger>
	}
export default TerritoriesRoutes;
